<template>
    <a class="nostyle" :href="project['link']" :target="project['link'] ? '_blank' : null">
        <div class="project" @mouseenter="hover = true" @mouseleave="hover = false">
            <div class="project-image">
                <img v-if="project['image']" :src="project['image']">
                <span v-else-if="project['image_initial']" class="monospaced">
                    {{ project['image_initial'] }}
                </span>
                <span v-else class="monospaced">
                    {{ project['name'][0] }}
                </span>
            </div>
            <div class="project-description">
                <h3 class="monospaced">{{ projectNameKebab }}</h3>
                <p v-for="line in project['description']">{{ line }}</p>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: 'ProjectItem',
    props: ['project'],
    data () {
        return {
            hover: false
        }
    },
    computed: {
        projectNameKebab: function () {
            if (this.hover) {
                return this.project['name'].toLowerCase().replace(/ +/g, '-')
            }
            return this.project['name']
        }
    }
}
</script>

<style>

.project {
    display: flex;
    flex-direction: row;
    margin: 25px 0;
    align-items: center;
}

.project h3 {
    margin: 0.5em 0 1em 0;
}

.project p{
    margin: 0;
}

.project-description h3 {
    transition: 0.1s padding ease-in-out, 0.2s background-color ease-in-out, 0.2s color ease-in-out, 0.2s font-weight;
}

.project:hover > .project-description h3::before {
    content: "./";
}

.project:hover > .project-description h3::after {
    content: " ↵";
    font-size: 0.8em;
}

.project:hover > .project-description h3 {
    color: white;
    font-weight: 400;
    padding: 0 0.5em;
    background-color: #222;
}

.project:hover {
    cursor: pointer;
}

.project-image {
    height: 100px;
    display: flex;
    align-items: center;
    justify-contents: center;
    padding: 0 25px;
}

.project-image img,span {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.project-image span:before{
    content: "/* ";
}

.project-image span:after{
    content: " */";
}

.project-image span {
    width: 100px;
    text-align: center;
    font-size: 1em;
}

.project-description {
    display: flex;
    flex-direction: column;
    padding: 0 25px;
    align-items: left;
    border-left: 2px solid black;
    width: calc(100% - 200px - 2px);
    max-width: 20em;
}

a.nostyle:link {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}

a.nostyle:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}
</style>



// WEBPACK FOOTER //
// ProjectItem.vue?3c5b5ba7